var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLickPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9,2 C5.136,2 2,5.136 2,9 C2,12.864 5.136,16 9,16 C12.864,16 16,12.864 16,9 C16,5.136 12.864,2 9,2 Z M9,14.6 C5.913,14.6 3.4,12.087 3.4,9 C3.4,5.913 5.913,3.4 9,3.4 C12.087,3.4 14.6,5.913 14.6,9 C14.6,12.087 12.087,14.6 9,14.6 Z",
    id: "lick-play_svg__path-lick-play"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lick-play_svg__\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lick-play_svg__\\u7248\\u5757\\u591A\\u79CD\\u72B6\\u6001-/-\\u64AD\\u653E",
    transform: "translate(-15.000000, -137.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lick-play_svg__grooves/riffs/licks\\u533A\\u57DF",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lick-play_svg__\\u7F16\\u7EC4-17",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lick-play_svg__\\u7F16\\u7EC4-groove-pattern\\u5907\\u4EFD-4",
    transform: "translate(0.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "lick-play_svg__\\u5FAA\\u73AFloop",
    transform: "translate(15.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "lick-play_svg__\\u77E9\\u5F62",
    fill: "#F2055B",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    rx: 4
  }), /*#__PURE__*/React.createElement("mask", {
    id: "lick-play_svg__mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#lick-play_svg__path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "lick-play_svg__icon/av/pause_circle_outline_24px",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#lick-play_svg__path-lick-play"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "lick-play_svg__Path",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    points: "7.5 12.75 12.5 9 7.5 5.25"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLickPlay);
export default __webpack_public_path__ + "static/media/lick-play.bff26bb3.svg";
export { ForwardRef as ReactComponent };